import ConditionalAlert from '@/components/conditional-alert/ConditionalAlert';
import { MittMeFooter } from '@/components/footer/footer';
import NetworkStatusBanner from '@/components/network-status-banner/NetworkStatusBanner';
import DebugToolbar from '@/pages/debug/components/DebugToolbar';
import { useDebug } from '@/pages/debug/contexts/DebugContext';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { AppBar, Box, Container, Link, Toolbar, Typography } from 'ui/mui';
import Routes from '../features/routes/Routes';
import {} from '../helpers/utils';
import { Sidebar } from 'ui';
import SidebarContent from './sidebar/components/SidebarContent';
import KundportalLogo from '@/components/KundportalLogo';
import { PrimaryButton } from 'ui/components/Button';
import { IconClose, IconMenu } from 'ui/Icons';

const drawerWidth = 260;
export const bottomNavigationHeight = 76;

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  useEffect(() => {
    setOpenMobileMenu(false);
  }, [location, setOpenMobileMenu]);
  const { showDebugToolbar } = useDebug();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'left',
        width: '100%',
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      {showDebugToolbar && <DebugToolbar />}
      <AppBar
        variant='outlined'
        sx={{
          backgroundColor: (theme) =>
            openMobileMenu
              ? theme.palette.background.paper
              : theme.palette.background.default,
          border: 'none',
          display: { xs: 'block', md: 'none' },
        }}
      >
        <Toolbar
          variant='dense'
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            px: 2,
            pt: 2,
            pb: 2,
          }}
        >
          <Link
            href='/'
            component='a'
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
          >
            <KundportalLogo sx={{ height: 35 }} />
          </Link>
          <PrimaryButton
            startIcon={openMobileMenu ? <IconClose /> : <IconMenu />}
            variant={openMobileMenu ? 'contained' : 'outlined'}
            onClick={() => setOpenMobileMenu(!openMobileMenu)}
            sx={{ alignSelf: 'center' }}
          >
            <Typography sx={{ fontWeight: 600 }}>Meny</Typography>
          </PrimaryButton>
        </Toolbar>
      </AppBar>
      <Sidebar
        openMobileMenu={openMobileMenu}
        setOpenMobileMenu={setOpenMobileMenu}
        drawerWidth={drawerWidth}
        logo={
          <RouterLink to='/'>
            <Box sx={{ ml: 2, mb: 4, display: 'block' }}>
              <KundportalLogo sx={{ height: 35, mt: 2 }} />
            </Box>
          </RouterLink>
        }
      >
        <SidebarContent />
      </Sidebar>
      <Box
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: { xs: '100%', md: `calc(100% - ${drawerWidth}px)` },
          mt: { xs: '96px', md: 0 },
        }}
      >
        <NetworkStatusBanner />
        <ConditionalAlert />
        <Container
          sx={{
            flexGrow: 1,
            my: { xs: 2, md: 5 },
          }}
        >
          <Routes />
        </Container>
        <MittMeFooter />
      </Box>
    </Box>
  );
};

export default Layout;
